import FlashLib from 'flashlib_onlyplay';
import animationCreator from 'Engine/animations/animationCreator';
import eAnimationTypes from '../../enums/eAnimationTypes';
import { eAnimationNames } from '../../enums/eAnimationNames';

export default class ControllerPopupBackgroundAnimation extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this.init();
    this.animationY = 0;
    this.addListeners();
  }

  async init() {
    animationCreator.createAnimationWithDelayedLoading(eAnimationTypes.BIG_WIN).then((data) => {
      this.animation = data;
      this.animation.y = this.animationY;
      this.animation.visible = false;
      this.addChild(this.animation);
    });
  }

  addListeners() {
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onResize,
      this
    );
  }

  onResize(data) {
    const animationYOffset = 50;
    const portraitYToBottomValue = 630;

    let y;
    if (data.isLandscape) {
      y = animationYOffset;
    } else {
      y = (data.stageY / data.scale) + animationYOffset;
      if (y > portraitYToBottomValue) {
        y = portraitYToBottomValue;
      }
    }
    this.animationY = y;
    if (this.animation) this.animation.y = y
  }

  start() {
    this.animation.visible = true;
    this.animation.state.setAnimation(0, eAnimationNames.EAN_POPUP_SHINE, true);
  }

  stop() {
    this.animation.visible = false;
    this.animation.state.clearTrack(0);
    this.animation.lastTime = null;
    this.animation.skeleton.setToSetupPose();
  }
}
